module.exports = __webpack_public_path__ + "img/goodsrope1.8d258b58.png";